<app-navbar appHideBreadcrumb>
    <h2>Lista Joburi Companie</h2>
    <div class="job-subtitle">
        <div class="breadcrumb-container">
            <a href="/" class="breadcrumb-text">Acasa</a>
            <span class="breadcrmb-slash">/</span>
            <a href="/joburi" class="breadcrumb-text">Joburi</a>
        </div>
    </div>
</app-navbar>

<section class="job-area job-area-two pt-100">
    <div class="container">
        <div class="row">
            <app-form-message [success]="duplicateResponse" *ngIf="duplicateSent"
                              [customSuccessMessage]="'Jobul a fost clonat cu succes! Vei fi redirectionat in scurt timp.'"></app-form-message>


            <div class="col-12 mb-5">
                <div class="d-flex justify-content-between">
                    <button routerLink="/companie/{{companyId}}" class="c-btn details-button" *ngIf="!isAuthor">Inapoi
                        la pagina companiei
                    </button>
                    <button routerLink="/compania-mea" class="c-btn details-button" *ngIf="isAuthor">Inapoi la Compania
                    </button>
                    <button routerLink="/adauga-job" class="c-btn details-button" *ngIf="isAuthor">Adauga Job</button>
                </div>
            </div>

            <div class="col-12 mb-5" *ngIf="jobsLoaded">
                <div class="no-applications-found" *ngIf="jobs.length === 0; else viewJobs">
                    <p>Nu exista niciun job activ.</p>
                </div>
                <ng-template #viewJobs>
                    <div class="tab mb-5" *ngIf="isAuthor">
                        <button [ngClass]="{'active': showAllJobs}" class="tablinks"
                                (click)="displayApps('all')">Toate({{jobs.length}})
                        </button>
                        <button [ngClass]="{'active': showPublishedJobs}" class="tablinks"
                                (click)="displayApps('published')">Publicate({{publishedJobs.length}})
                        </button>
                        <button [ngClass]="{'active': showArchivedJobs}" class="tablinks"
                                (click)="displayApps('archived')">Arhivate({{archivedJobs.length}})
                        </button>
                        <button [ngClass]="{'active': showUnpublishedJobs}" class="tablinks"
                                (click)="displayApps('pending_review')">In asteptare({{unpublishedJobs.length}})
                        </button>
                        <button [ngClass]="{'active': showDraftJobs}" class="tablinks"
                                (click)="displayApps('draft')">Ciorne({{draftJobs.length}})
                        </button>
                        <button [ngClass]="{'active': showExpiredJobs}" class="tablinks"
                                (click)="displayApps('expired')">Expirate({{expiredJobs.length}})
                        </button>
                    </div>
                    <div class="select-tab">
                        <!--All Jobs TAB-->
                        <div *ngIf="showAllJobs" class="view-all-company-jobs">
                            <div class="view-application-single" *ngFor="let job of jobs">
                                <div class="bg-white p-10 mb-5">
                                    <div class="row align-items-center">
                                        <div class="col-md-1 col-12 text-center">
                                            <img src="{{job.photoPath}}" class="img-fluid"
                                                 alt="Job">
                                        </div>
                                        <div class="col-md-5 text-md-left col-12 text-center">
                                            <a routerLink="/job/{{job.id}}"
                                               class="title-link mb-2 d-block">{{job.jobTitle}}</a>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-location-pin green-color mr-2"></i>{{job.country}}, {{job.city}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-money-bag green-color mr-2"></i>{{job.salary}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-worker green-color mr-2"></i>{{job.workType | enumTransform}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-workers-group green-color mr-2"></i>{{job.openPositions}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-calendar green-color mr-2"></i>Data
                                                    Postare {{job.jobPostingDate | date:"dd-MM-yyyy"}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-label green-color mr-2"></i>Status:
                                                    <span class="red-message">{{job.status | enumTransform}}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6 col-12  job-buttons">
                                            <ul class="list-unstyled m-0 text-md-right text-center">
                                                <li class="d-inline-block mb-md-0 mb-2">
                                                    <a routerLink="/job/{{job.id}}">
                                                        <button class="c-btn details-button">Vezi Job</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a (click)="duplicateJob(job.id)">
                                                        <button class="c-btn btn btn-secondary">Duplica job</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/editare-job/{{job.id}}">
                                                        <button class="c-btn edit-button">Modifica</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <button class="c-btn delete-button" (click)="statusModal.show()">
                                                        Status
                                                    </button>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/aplicatii/{{job.id}}">
                                                        <button class="c-btn list-candidates-button">
                                                            Lista Candidati
                                                        </button>
                                                    </a>
                                                </li>

                                            </ul>
                                        </div>
                                        <!--Change Status Modal Component-->
                                        <app-modal #statusModal>
                                            <div class="app-modal-header">
                                                <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                                            </div>
                                            <div class="app-modal-body">

                                                <select [(ngModel)]="jobStatus">
                                                    <option selected disabled value="">Selecteaza un status</option>
                                                    <option value="Published">Publicat</option>
                                                    <option value="Draft">Ciorna</option>
                                                    <option value="Pending_review">In asteptare</option>
                                                    <option value="Expired">Expirat</option>
                                                    <option value="Archived">Arhivat</option>
                                                </select>
                                                <span class="red-message d-block" *ngIf="jobStatus === ''">
                                                </span>
                                                <span class="red-message d-block" *ngIf="jobStatus === 'Published'">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in Publicat?
                                                </span>
                                                <span class="red-message d-block" *ngIf="jobStatus === 'Draft'">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in Ciornă?
                                                </span>
                                                <span class="red-message d-block" *ngIf="jobStatus === 'Pending_review'">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in În așteptare?
                                                </span>
                                                <span class="red-message d-block" *ngIf="jobStatus === 'Expired'">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in Expirat?
                                                </span>
                                                <span class="red-message d-block" *ngIf="jobStatus === 'Archived'">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in Arhivat?
                                                </span>

                                            </div>
                                            <div class="app-modal-footer">
                                                <button type="button"
                                                        class="btn list-candidates-button mr-2"
                                                        (click)="statusModal.hide()">
                                                    Renunta
                                                </button>
                                                <button type="button" class="btn delete-button"
                                                        (click)="changeJobStatus(job.id, jobStatus); statusModal.hide()">
                                                    Actualizeaza
                                                </button>
                                            </div>
                                        </app-modal>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Published Jobs TAB-->
                        <div *ngIf="showPublishedJobs" class="view-all-published">
                            <div class="no-applications-found" *ngIf="publishedJobs.length == 0">
                                <p>Nu ai joburi active.</p>
                            </div>
                            <div class="view-application-single" *ngFor="let job of publishedJobs">
                                <div class="bg-white p-10 mb-5">
                                    <div class="row align-items-center">
                                        <div class="col-md-1 col-12 text-center">
                                            <img src="{{job.photoPath}}" class="img-fluid"
                                                 alt="Job">
                                        </div>
                                        <div class="col-md-5 text-md-left col-12 text-center">
                                            <a routerLink="/job/{{job.id}}"
                                               class="title-link mb-2 d-block">{{job.jobTitle}}</a>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-location-pin green-color mr-2"></i>{{job.country}}, {{job.city}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-money-bag green-color mr-2"></i>{{job.salary}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-worker green-color mr-2"></i>{{job.workType | enumTransform}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-workers-group green-color mr-2"></i>{{job.openPositions}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-calendar green-color mr-2"></i>Data
                                                    Postare {{job.startDate | date:"dd-MM-yyyy"}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-label green-color mr-2"></i>Status:
                                                    <span class="red-message">{{job.status | enumTransform}}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <ul class="list-unstyled m-0 text-md-right text-center">
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                    <a routerLink="/job/{{job.id}}">
                                                        <button class="c-btn details-button">Vezi Job</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/editare-job/{{job.id}}">
                                                        <button class="c-btn edit-button">Modifica</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/aplicatii/{{job.id}}">
                                                        <button class="c-btn list-candidates-button">
                                                            Lista Candidati
                                                        </button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <button class="c-btn delete-button" (click)="statusModal.show()">
                                                        Status
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <!--Change Status Modal Component-->
                                        <app-modal #statusModal>
                                            <div class="app-modal-header">
                                                <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                                            </div>
                                            <div class="app-modal-body">

                                                <select [(ngModel)]="jobStatus">
                                                    <option selected disabled value="">Selecteaza un status</option>
                                                    <option value="Published">Published</option>
                                                    <option value="Draft">Draft</option>
                                                    <option value="Pending_review">Pending Review</option>
                                                    <option value="Expired">Expired</option>
                                                    <option value="Archived">Archived</option>
                                                </select>

                                                <span class="red-message d-block">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in {{jobStatus}}?
                                                </span>


                                            </div>
                                            <div class="app-modal-footer">
                                                <button type="button"
                                                        class="btn list-candidates-button mr-2"
                                                        (click)="statusModal.hide()">
                                                    Renunta
                                                </button>
                                                <button type="button" class="btn delete-button"
                                                        (click)="changeJobStatus(job.id, jobStatus); statusModal.hide()">
                                                    Actualizeaza
                                                </button>
                                            </div>
                                        </app-modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Archived Jobs TAB-->
                        <div *ngIf="showArchivedJobs" class="view-all-archived">
                            <div class="no-applications-found" *ngIf="archivedJobs.length == 0">
                                <p>Nu ai joburi arhivate.</p>
                            </div>
                            <div class="view-application-single" *ngFor="let job of archivedJobs">
                                <div class="bg-white p-10 mb-5">
                                    <div class="row align-items-center">
                                        <div class="col-md-1 col-12 text-center">
                                            <img src="{{job.photoPath}}" class="img-fluid"
                                                 alt="Job">
                                        </div>
                                        <div class="col-md-5 text-md-left col-12 text-center">
                                            <a routerLink="/job/{{job.id}}"
                                               class="title-link mb-2 d-block">{{job.jobTitle}}</a>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-location-pin green-color mr-2"></i>{{job.country}}, {{job.city}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-money-bag green-color mr-2"></i>{{job.salary}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-worker green-color mr-2"></i>{{job.workType | enumTransform}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-workers-group green-color mr-2"></i>{{job.openPositions}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-calendar green-color mr-2"></i>Data
                                                    Postare {{job.startDate | date:"dd-MM-yyyy"}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-label green-color mr-2"></i>Status:
                                                    <span class="red-message">{{job.status | enumTransform}}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <ul class="list-unstyled m-0 text-md-right text-center">
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                    <a routerLink="/job/{{job.id}}">
                                                        <button class="c-btn details-button">Vezi Job</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/editare-job/{{job.id}}">
                                                        <button class="c-btn edit-button">Modifica</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/aplicatii/{{job.id}}">
                                                        <button class="c-btn list-candidates-button">
                                                            Lista Candidati
                                                        </button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <button class="c-btn delete-button" (click)="statusModal.show()">
                                                        Status
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <!--Change Status Modal Component-->
                                        <app-modal #statusModal>
                                            <div class="app-modal-header">
                                                <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                                            </div>
                                            <div class="app-modal-body">

                                                <select [(ngModel)]="jobStatus">
                                                    <option selected disabled value="">Selecteaza un status</option>
                                                    <option value="Published">Published</option>
                                                    <option value="Draft">Draft</option>
                                                    <option value="Pending_review">Pending Review</option>
                                                    <option value="Expired">Expired</option>
                                                    <option value="Archived">Archived</option>
                                                </select>

                                                <span class="red-message d-block">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in {{jobStatus}}?
                                                </span>


                                            </div>
                                            <div class="app-modal-footer">
                                                <button type="button"
                                                        class="btn list-candidates-button mr-2"
                                                        (click)="statusModal.hide()">
                                                    Renunta
                                                </button>
                                                <button type="button" class="btn delete-button"
                                                        (click)="changeJobStatus(job.id, jobStatus); statusModal.hide()">
                                                    Actualizeaza
                                                </button>
                                            </div>
                                        </app-modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Unpublished Jobs TAB-->
                        <div *ngIf="showUnpublishedJobs" class="view-all-unpublished">
                            <div class="no-applications-found" *ngIf="unpublishedJobs.length == 0">
                                <p>Nu ai joburi inactive.</p>
                            </div>
                            <div class="view-application-single" *ngFor="let job of unpublishedJobs">
                                <div class="bg-white p-10 mb-5">
                                    <div class="row align-items-center">
                                        <div class="col-md-1 col-12 text-center">
                                            <img src="{{job.photoPath}}" class="img-fluid"
                                                 alt="Job">
                                        </div>
                                        <div class="col-md-5 text-md-left col-12 text-center">
                                            <a routerLink="/job/{{job.id}}"
                                               class="title-link mb-2 d-block">{{job.jobTitle}}</a>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-location-pin green-color mr-2"></i>{{job.country}}, {{job.city}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-money-bag green-color mr-2"></i>{{job.salary}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-worker green-color mr-2"></i>{{job.workType | enumTransform}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-workers-group green-color mr-2"></i>{{job.openPositions}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-calendar green-color mr-2"></i>Data
                                                    Postare {{job.startDate | date:"dd-MM-yyyy"}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-label green-color mr-2"></i>Status:
                                                    <span class="red-message">{{job.status | enumTransform}}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <ul class="list-unstyled m-0 text-md-right text-center">
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                    <a routerLink="/job/{{job.id}}">
                                                        <button class="c-btn details-button">Vezi Job</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/editare-job/{{job.id}}">
                                                        <button class="c-btn edit-button">Modifica</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/aplicatii/{{job.id}}">
                                                        <button class="c-btn list-candidates-button">
                                                            Lista Candidati
                                                        </button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <button class="c-btn delete-button" (click)="statusModal.show()">
                                                        Status
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <!--Change Status Modal Component-->
                                        <app-modal #statusModal>
                                            <div class="app-modal-header">
                                                <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                                            </div>
                                            <div class="app-modal-body">

                                                <select [(ngModel)]="jobStatus">
                                                    <option selected disabled value="">Selecteaza un status</option>
                                                    <option value="Published">Published</option>
                                                    <option value="Draft">Draft</option>
                                                    <option value="Pending_review">Pending Review</option>
                                                    <option value="Expired">Expired</option>
                                                    <option value="Archived">Archived</option>
                                                </select>

                                                <span class="red-message d-block">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in {{jobStatus}}?
                                                </span>


                                            </div>
                                            <div class="app-modal-footer">
                                                <button type="button"
                                                        class="btn list-candidates-button mr-2"
                                                        (click)="statusModal.hide()">
                                                    Renunta
                                                </button>
                                                <button type="button" class="btn delete-button"
                                                        (click)="changeJobStatus(job.id, jobStatus); statusModal.hide()">
                                                    Actualizeaza
                                                </button>
                                            </div>
                                        </app-modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Draft Jobs TAB-->
                        <div *ngIf="showDraftJobs" class="view-all-draft">
                            <div class="no-applications-found" *ngIf="draftJobs.length == 0">
                                <p>Nu ai ciorne.</p>
                            </div>
                            <div class="view-application-single" *ngFor="let job of draftJobs">
                                <div class="bg-white p-10 mb-5">
                                    <div class="row align-items-center">
                                        <div class="col-md-1 col-12 text-center">
                                            <img src="{{job.photoPath}}" class="img-fluid"
                                                 alt="Job">
                                        </div>
                                        <div class="col-md-5 text-md-left col-12 text-center">
                                            <a routerLink="/job/{{job.id}}"
                                               class="title-link mb-2 d-block">{{job.jobTitle}}</a>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-location-pin green-color mr-2"></i>{{job.country}}, {{job.city}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-money-bag green-color mr-2"></i>{{job.salary}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-worker green-color mr-2"></i>{{job.workType | enumTransform}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-workers-group green-color mr-2"></i>{{job.openPositions}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-calendar green-color mr-2"></i>Data
                                                    Postare {{job.startDate | date:"dd-MM-yyyy"}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-label green-color mr-2"></i>Status:
                                                    <span class="red-message">{{job.status | enumTransform}}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <ul class="list-unstyled m-0 text-md-right text-center">
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                    <a routerLink="/job/{{job.id}}">
                                                        <button class="c-btn details-button">Vezi Job</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/editare-job/{{job.id}}">
                                                        <button class="c-btn edit-button">Modifica</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/aplicatii/{{job.id}}">
                                                        <button class="c-btn list-candidates-button">
                                                            Lista Candidati
                                                        </button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <button class="c-btn delete-button" (click)="statusModal.show()">
                                                        Status
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <!--Change Status Modal Component-->
                                        <app-modal #statusModal>
                                            <div class="app-modal-header">
                                                <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                                            </div>
                                            <div class="app-modal-body">

                                                <select [(ngModel)]="jobStatus">
                                                    <option selected disabled value="">Selecteaza un status</option>
                                                    <option value="Published">Published</option>
                                                    <option value="Draft">Draft</option>
                                                    <option value="Pending_review">Pending Review</option>
                                                    <option value="Expired">Expired</option>
                                                    <option value="Archived">Archived</option>
                                                </select>

                                                <span class="red-message d-block">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in {{jobStatus}}?
                                                </span>


                                            </div>
                                            <div class="app-modal-footer">
                                                <button type="button"
                                                        class="btn list-candidates-button mr-2"
                                                        (click)="statusModal.hide()">
                                                    Renunta
                                                </button>
                                                <button type="button" class="btn delete-button"
                                                        (click)="changeJobStatus(job.id, jobStatus); statusModal.hide()">
                                                    Actualizeaza
                                                </button>
                                            </div>
                                        </app-modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Expired Jobs TAB-->
                        <div *ngIf="showExpiredJobs" class="view-all-expired">
                            <div class="no-applications-found" *ngIf="expiredJobs.length == 0">
                                <p>Nu ai joburi expirate.</p>
                            </div>
                            <div class="view-application-single" *ngFor="let job of expiredJobs">
                                <div class="bg-white p-10 mb-5">
                                    <div class="row align-items-center">
                                        <div class="col-md-1 col-12 text-center">
                                            <img src="{{job.photoPath}}" class="img-fluid"
                                                 alt="Job">
                                        </div>
                                        <div class="col-md-5 text-md-left col-12 text-center">
                                            <a routerLink="/job/{{job.id}}"
                                               class="title-link mb-2 d-block">{{job.jobTitle}}</a>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-location-pin green-color mr-2"></i>{{job.country}}, {{job.city}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-money-bag green-color mr-2"></i>{{job.salary}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-worker green-color mr-2"></i>{{job.workType | enumTransform}}
                                                </li>
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-workers-group green-color mr-2"></i>{{job.openPositions}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-calendar green-color mr-2"></i>Data
                                                    Postare {{job.startDate | date:"dd-MM-yyyy"}}
                                                </li>
                                            </ul>
                                            <ul class="list-unstyled">
                                                <li class="d-inline-block mr-2 blue-color">
                                                    <i class="icofont-label green-color mr-2"></i>Status:
                                                    <span class="red-message">{{job.status | enumTransform}}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <ul class="list-unstyled m-0 text-md-right text-center">
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                    <a routerLink="/job/{{job.id}}">
                                                        <button class="c-btn details-button">Vezi Job</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/editare-job/{{job.id}}">
                                                        <button class="c-btn edit-button">Modifica</button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <a routerLink="/aplicatii/{{job.id}}">
                                                        <button class="c-btn list-candidates-button">
                                                            Lista Candidati
                                                        </button>
                                                    </a>
                                                </li>
                                                <li class="d-inline-block mb-md-0 mb-2" *ngIf="isAuthor">
                                                    <button class="c-btn delete-button" (click)="statusModal.show()">
                                                        Status
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <!--Change Status Modal Component-->
                                        <app-modal #statusModal>
                                            <div class="app-modal-header">
                                                <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                                            </div>
                                            <div class="app-modal-body">

                                                <select [(ngModel)]="jobStatus">
                                                    <option selected disabled value="">Selecteaza un status</option>
                                                    <option value="Published">Published</option>
                                                    <option value="Draft">Draft</option>
                                                    <option value="Pending_review">Pending Review</option>
                                                    <option value="Expired">Expired</option>
                                                    <option value="Archived">Archived</option>
                                                </select>

                                                <span class="red-message d-block">
                                                    Esti sigur ca vrei sa schimbi statusul acestui job in {{jobStatus}}?
                                                </span>


                                            </div>
                                            <div class="app-modal-footer">
                                                <button type="button"
                                                        class="btn list-candidates-button mr-2"
                                                        (click)="statusModal.hide()">
                                                    Renunta
                                                </button>
                                                <button type="button" class="btn delete-button"
                                                        (click)="changeJobStatus(job.id, jobStatus); statusModal.hide()">
                                                    Actualizeaza
                                                </button>
                                            </div>
                                        </app-modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
